import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export async function toggleNotifications(
  data: { parent: string; parentEnabled: boolean } | { child: string; childEnabled: boolean },
) {
  const url = occUrl("/notifications/settings/update");

  const response = await occFetch(url, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
  });

  return await response.json();
}
